export default __webpack_public_path__ + "3df5922b7dd66d6b8b2800aab008e03b.svg";